import { render, staticRenderFns } from "./BusinessDetail.vue?vue&type=template&id=2072a56c"
import script from "./BusinessDetail.vue?vue&type=script&lang=js"
export * from "./BusinessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports